<template>
    <div class="captail_wrap registrationSteps position-relative fullLoader p-0 w-100">
		<loader v-if="pageLoader"></loader> 
        
        <div class="middle_section m-0">
            <div class="top_searchbars">
                <div class="row">
                    <div class="col-12">
					   <div class="cap_logo_steps p-3 d-flex justify-content-between align-items-center">
							 <router-link to="/home"><img src="../../../../../static/website/images/logo.png" alt="Captail wallet"></router-link>
							<div class="rightBack d-flex align-items-center">
							<router-link class="backToDash" :to="'/home'"><feather type="home"></feather></router-link>
						    </div>
						</div>
                    </div>
                </div>
            </div>
            <div class="mid_scroll_content d-flex align-items-center justify-content-center">
                <section class="stepsForm-include  valigncenter border-0 w-100">
                    <div class="row justify-content-center">
                    <alert-notification v-if="notification_msg != ''"/>
                        <div class="col-12 col-lg-8 stepBorder box-shadow addWidth-res text-center">
                         <h3 class="text-center mb-md-5">Company Information</h3>
                            <div class="mt-4">
                                <div class="row personalInfo">
									<div class="col-md-6">
                                        <div class="form-group">
                                            <label class="labeltext">Legal Type Of The Entity</label>
											<select class="form-control" name="org_type" v-model="org_type" v-validate="'required'" placeholder=" " onclick="this.setAttribute('value', this.value);" value="" ref="org_type">
												<option value=""></option>
												<option value="1">Company</option>
												<option value="2">Self Managed Super Fund</option>
												<option value="3">Discretionary/Unit Trust</option>
												<option value="4">Others</option>
											</select>
											<span v-show="submitted && errors.has('org_type')" class="text-danger">The Legal Type  is required</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="labeltext">Legal Name Of The Entity</label>
                                            <input type="text" class="form-control" name="legal_name" v-model="legal_name" v-validate="'required'" placeholder=" ">
											<span v-show="submitted && errors.has('legal_name')" class="text-danger">The Legal Name is required</span>
                                        </div>
                                    </div>
                                    
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="labeltext">Address Of The Entity's Offices </label>
                                            <input type="text" class="form-control" name="org_address"  v-model="org_address" v-validate="'required'" placeholder=" ">
											<span v-show="submitted && errors.has('org_address')" class="text-danger">The Address is required</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group" :class="(registered_country != '')? 'active' : ''">
											<label class="labeltext">Country Where The Entiy Is Registered In </label>
											<v-select :options="Object.values($env_var.countriesList)" :reduce="country => country.code" v-model="registered_country" label="name" placeholder=" " name="registered_country"  :autocomplete="'off'" v-validate="'required'" ></v-select>
											<span v-show="submitted && errors.has('registered_country')" class="text-danger">The registered country is required</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="labeltext">Nature of Business of The Entity & Source Of Funds  </label>
                                            <input type="text" class="form-control" name="src_of_funds" v-model="src_of_funds" v-validate="'required'" placeholder=" ">
											<span v-show="submitted && errors.has('src_of_funds')" class="text-danger">The fund is required</span>
                                        </div>
                                    </div>
									<div class="col-md-6">
                                        <div class="form-group">
                                            <label class="labeltext"> Entity's Registeration Number</label>
                                            <input type="text" class="form-control" name="tax_id" v-model="tax_id" v-validate="'required'" placeholder=" ">
											<span v-show="submitted && errors.has('tax_id')" class="text-danger">The Registeration Number is required</span>
                                        </div>
                                    </div>
                                    
                                    <div class="col-12">
                                        <div class="submitButton text-center my-4">
                                            <input type="button" class="cap_btn blue px-4 large_btn" value="Save & Continue" :class="(pageLoader)?'disabled':''" v-on:click.stop.prevent="submit">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import { registerStepsMixins } from '@/plugins/registerSteps'
export default {
    name: 'step-four',
    mixins: [registerStepsMixins],
    data() {
        return {
			submitted : false,
			pageLoader : false,
            notification_msg:'',
            notification_type:'',
			org_type : '0',
			legal_name : '',
			org_address : '',
			registered_country : '',
			src_of_funds : '',
			tax_id : ''
		}
    },
	methods: {
		submit(){
            if(this.pageLoader){return;}
			const _that = this
			this.submitted = true;
			this.$validator.validate().then(valid => {
                if(!this.$env_var.countriesList[_that.registered_country]){
                    _that.registered_country = ''
                    return
                }
				else if (valid) {
					let input_json={
						'globalParams' :{
							"org_type" : _that.org_type, 
							"legal_name" : _that.legal_name,
							"org_address" : _that.org_address, 
							"registered_country" : _that.registered_country, 
							"src_of_funds" : _that.src_of_funds, 
							"tax_id" : _that.tax_id,
							'step' : '1'
						},
						'localParams' :{ "parameter" : _that }
					}
					_that._runCorStep4(input_json)
				}
			})
		}
	},
	created(){
		this._runGetStepInfo({'globalParams' :{"step" : '1'},'localParams' :{ "parameter" : this}})
        let _that = this
        setTimeout(function(){ _that.$refs.org_type.click() }, 300);

	}
	
}
</script>



// WEBPACK FOOTER //
// src/components/website/registerSteps/corporate/corporate_step1.vue